import styled from 'styled-components';
import { NavLink } from 'react-router-dom';
import { RegularButton } from 'pg-ui-library';
import NotFound from '../../assets/not-found.png';

export const Container = styled.div`
  height: 90vh;
  width: 100%;
  background-image: url(${NotFound});
  display: flex;
  align-items: end;
  justify-content: center;
  background-repeat: no-repeat;
  background-size: cover;
`;

export const MessageContainer = styled.div`
  height: 25vh;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
`;

export const Title = styled.h1`
  font-size: 24px;
  color: #4d6ffb;
  font-weight: 600;
  text-transform: uppercase;
`;

export const LinkWrapper = styled(NavLink)`
  text-decoration: none;
`;

export const RedirectButton = styled(RegularButton)`
  text-transform: uppercase;
`;
